var option_webview_default = {
  "option": "_6GBjU",
  "user_choice": "suId0",
  "check": "_1DGW5",
  "image": "-C4JM",
  "input": "q0oR9",
  "title": "cgj6U",
  "centered": "tstrr",
  "with_result": "jP6Lv",
  "list": "C1YiH",
  "with_image": "uV9Ui",
  "progress": "_09EJ8",
  "progress_value": "xU9xq",
  "label": "tHa-k",
  "cta": "jcMtG",
  "adornment_icon": "cVtj3",
  "remove": "AGfbL",
  "removeButton": "FhGtf",
  "removeButtonIcon": "-v75G",
  "overlay": "l8eLf",
  "shown": "Jcodl",
  "dark": "gnkFe",
  "spinner": "Reb2g",
  "spin": "eEI-S",
  "grid": "HC-C6"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
